import { Link, NavLink } from 'react-router-dom';
import './AcercaDe.css';
import { useLanguage } from '../i18n/LanguageContext';

export default function AcercaDe() {
  const { t, lang, toggleLanguage } = useLanguage();

  return (
    <div className="app">
      <header className="page-hero">
        <nav className="nav">
          <Link to="/" className="brand-link">
            <img
              src="/ceam-logo.png"
              className="brand-logo"
              alt="Centro Educativo Adventista de Monteverde"
            />
            <div className="brand-text">
              <span className="brand-title">{t('common.brand')}</span>
              <span className="brand-subtitle">{t('common.schoolName')}</span>
            </div>
          </Link>
          <div className="nav-actions">
            <NavLink to="/" className="btn ghost">{t('nav.home')}</NavLink>
            <NavLink to="/admisiones" className="btn ghost">{t('nav.admissions')}</NavLink>
            <NavLink to="/acerca-de" className="btn ghost">{t('nav.about')}</NavLink>
            <NavLink to="/ubicacion" className="btn ghost">{t('nav.contact')}</NavLink>
            <NavLink to="/voluntariado" className="btn ghost">{t('nav.volunteer')}</NavLink>
            <button type="button" className="btn ghost lang-toggle" onClick={toggleLanguage}>
              {lang === 'es' ? 'EN' : 'ES'}
            </button>
          </div>
        </nav>
      </header>

      <section className="section">
        <div className="about-header">
          <h1>{t('about.title')}</h1>
          <p className="lead">{t('about.lead')}</p>
        </div>
      </section>

      <section className="section alt">
        <div className="content-wrapper">
          <div className="about-section">
            <h2>{t('about.historyTitle')}</h2>
            <p>{t('about.historyP1')}</p>
            <p>{t('about.historyP2')}</p>
          </div>

          <div className="about-section">
            <h2>{t('about.missionTitle')}</h2>
            <p>{t('about.missionP1')}</p>
          </div>

          <div className="about-section">
            <h2>{t('about.valuesTitle')}</h2>
            <ul className="values-list">
              <li><strong>{t('about.value1')}:</strong> {t('about.value1Text')}</li>
              <li><strong>{t('about.value2')}:</strong> {t('about.value2Text')}</li>
              <li><strong>{t('about.value3')}:</strong> {t('about.value3Text')}</li>
              <li><strong>{t('about.value4')}:</strong> {t('about.value4Text')}</li>
              <li><strong>{t('about.value5')}:</strong> {t('about.value5Text')}</li>
            </ul>
          </div>

          <div className="about-section">
            <h2>{t('about.chooseTitle')}</h2>
            <div className="features-grid">
              <div className="feature">
                <h3>✨ {t('about.feature1Title')}</h3>
                <p>{t('about.feature1Text')}</p>
              </div>
              <div className="feature">
                <h3>🎓 {t('about.feature2Title')}</h3>
                <p>{t('about.feature2Text')}</p>
              </div>
              <div className="feature">
                <h3>💙 {t('about.feature3Title')}</h3>
                <p>{t('about.feature3Text')}</p>
              </div>
              <div className="feature">
                <h3>🤝 {t('about.feature4Title')}</h3>
                <p>{t('about.feature4Text')}</p>
              </div>
              <div className="feature">
                <h3>🌍 {t('about.feature5Title')}</h3>
                <p>{t('about.feature5Text')}</p>
              </div>
              <div className="feature">
                <h3>🔧 {t('about.feature6Title')}</h3>
                <p>{t('about.feature6Text')}</p>
              </div>
            </div>
          </div>

          <div className="about-section">
            <h2>{t('about.statsTitle')}</h2>
            <div className="stats-grid">
              <div className="stat">
                <h3>25+</h3>
                <p>{t('about.years')}</p>
              </div>
              <div className="stat">
                <h3>50+</h3>
                <p>{t('about.students')}</p>
              </div>
              <div className="stat">
                <h3>9</h3>
                <p>{t('about.teachers')}</p>
              </div>
              <div className="stat">
                <h3>1</h3>
                <p>{t('about.vision')}</p>
              </div>
            </div>
          </div>

          <div className="about-section documents-section">
            <h2>{t('about.documentsTitle')}</h2>
            <p>{t('about.documentsNote')}</p>
            <ul className="documents-list">
              <li>
                <a
                  className="document-link"
                  href="/docs/Normativa-de-Evaluacion-CEAM-2026.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >
                  {t('about.documentsNormative')}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="section contact-cta">
        <div className="cta-content">
          <h2>{t('about.ctaTitle')}</h2>
          <p>{t('about.ctaText')}</p>
          <div className="cta-actions">
            <a href="https://wa.me/50662857770" target="_blank" rel="noopener noreferrer" className="btn primary">
              {t('about.ctaNow')}
            </a>
            <Link to="/ubicacion" className="btn primary">{t('nav.contact')}</Link>
          </div>
        </div>
      </section>

      <footer className="footer">
        <p>{t('footer.rights')}</p>
      </footer>
    </div>
  );
}
